import React from 'react'
import { Button, Typography } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import Image from '../../../Atoms/Image'
import { useBanner } from '../hooks'
import type { BannersJSON } from '../types'
import { BANNER_TYPES } from '../types'
import styles from './index.module.css'

interface BlockProps {
  bannersJSON?: BannersJSON
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

function Block({ bannersJSON, onClick, ...props }: Readonly<BlockProps>) {
  const { bannerInformation } = useBanner({
    bannersJSON,
    bannerType: BANNER_TYPES.BLOCK,
  })

  if (!bannerInformation) return null

  return (
    <section className={styles.releaseBanner} {...props}>
      <div className={styles.mainContainer}>
        <div className={styles.innerContainer}>
          <div className={styles.textContainer}>
            <Typography variant="title" size="m" as="h4">
              {bannerInformation.title[0] ?? ''}
            </Typography>
            <Typography variant="body" size="l" as="p">
              {bannerInformation.description ?? ''}
            </Typography>
          </div>
          <Button
            variant="filled-rounded"
            trailingIcon={<IconArrowRight />}
            size="medium"
            as="a"
            href={bannerInformation.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
          >
            {bannerInformation.ctaText ?? ''}
          </Button>
        </div>
        <Image.Picture
          images={bannerInformation.image.srcSet}
          alt={bannerInformation.image.alt ?? ''}
          loading="lazy"
          aspectRatio="1"
          layout="cover"
        />
      </div>
    </section>
  )
}

Block.displayName = 'Block'
export default Block
